import { render } from "./MpfSettingDetail.vue?vue&type=template&id=4d610a84"
import script from "./MpfSettingDetail.vue?vue&type=script&lang=js"
export * from "./MpfSettingDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\ekk-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__